import { render, staticRenderFns } from "./Personalize.vue?vue&type=template&id=c87405fa&scoped=true&"
import script from "./Personalize.vue?vue&type=script&lang=js&"
export * from "./Personalize.vue?vue&type=script&lang=js&"
import style0 from "./Personalize.vue?vue&type=style&index=0&id=c87405fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87405fa",
  null
  
)

export default component.exports